<div class="button-container">
  <button mat-raised-button color="accent" (click)="login()">
    Login
  </button>
</div>
